<template>
  <div v-if="modelValue" class="image-zoom-overlay" role="dialog" aria-modal="true" aria-label="بزرگ‌نمایی تصویر" @click.self="close" @wheel.prevent="handleWheel">
    <button class="image-zoom-close" type="button" aria-label="بستن تصویر" @click="close">×</button>
    <div class="image-zoom-stage" @dblclick.prevent="toggleZoom">
      <img :src="src" :alt="alt" :style="{ transform: `scale(${zoom})` }" draggable="false">
    </div>
    <div class="image-zoom-controls" @click.stop>
      <button type="button" aria-label="کوچک‌نمایی" :disabled="zoom <= 1" @click="changeZoom(-0.25)">−</button>
      <input v-model.number="zoom" type="range" min="1" max="4" step="0.1" aria-label="میزان بزرگ‌نمایی">
      <span>{{ Math.round(zoom * 100) }}٪</span>
      <button type="button" aria-label="بزرگ‌نمایی" :disabled="zoom >= 4" @click="changeZoom(0.25)">+</button>
      <button type="button" class="zoom-reset" :disabled="zoom === 1" @click="zoom = 1">بازنشانی</button>
    </div>
    <p class="image-zoom-hint">برای بزرگ‌نمایی از دکمه‌ها یا چرخ ماوس استفاده کنید؛ دوبار کلیک برای بزرگ‌نمایی سریع</p>
  </div>
</template>

<script>
export default {
  name: 'ImageZoomOverlay',
  props: {
    modelValue: { type: Boolean, default: false },
    src: { type: String, default: '' },
    alt: { type: String, default: 'تصویر کالا' },
  },
  emits: ['update:modelValue'],
  data() {
    return { zoom: 1 }
  },
  watch: {
    modelValue(isOpen) {
      if (isOpen) this.zoom = 1
    },
  },
  methods: {
    close() {
      this.$emit('update:modelValue', false)
    },
    changeZoom(amount) {
      this.zoom = Math.min(4, Math.max(1, Math.round((this.zoom + amount) * 100) / 100))
    },
    handleWheel(event) {
      this.changeZoom(event.deltaY < 0 ? 0.2 : -0.2)
    },
    toggleZoom() {
      this.zoom = this.zoom === 1 ? 2 : 1
    },
  },
}
</script>

<style scoped>
.image-zoom-overlay { position: fixed; z-index: 12000; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 14px; padding: 56px 14px 20px; background: rgba(5, 8, 15, .94); color: #fff; }
.image-zoom-close { position: absolute; top: max(14px, env(safe-area-inset-top)); inset-inline-end: 16px; display: grid; place-items: center; width: 42px; height: 42px; border: 1px solid rgba(255,255,255,.24); border-radius: 50%; background: rgba(255,255,255,.12); color: #fff; font-size: 28px; cursor: pointer; }
.image-zoom-stage { display: grid; place-items: center; width: 100%; height: min(76vh, 900px); overflow: auto; touch-action: pan-x pan-y; }
.image-zoom-stage img { max-width: 100%; max-height: 100%; object-fit: contain; transition: transform .12s ease; transform-origin: center; user-select: none; }
.image-zoom-controls { display: flex; align-items: center; justify-content: center; gap: 10px; width: min(100%, 420px); }
.image-zoom-controls button { min-width: 38px; height: 38px; border: 1px solid rgba(255,255,255,.24); border-radius: 10px; background: rgba(255,255,255,.12); color: white; font: inherit; font-size: 20px; cursor: pointer; }
.image-zoom-controls button:disabled { opacity: .4; cursor: default; }
.image-zoom-controls input { width: min(35vw, 150px); accent-color: #60a5fa; }
.image-zoom-controls span { min-width: 48px; text-align: center; direction: ltr; }
.image-zoom-controls .zoom-reset { min-width: 74px; font-size: 12px; }
.image-zoom-hint { margin: 0; color: rgba(255,255,255,.72); font-size: 12px; text-align: center; }
</style>
